export const text = {
  HR: "HR",
  HolidayList: "Feestdagenlijst",
  LeavePolicy: "Verlofbeleid",
  LeaveAllocation: "Verloftoewijzing",
  LeaveType: "Verloftype",
  AllocatedLeaves: "Toegewezen verlofdagen",
  UsedLeaves: "Gebruikte verlofdagen",
  BalanceLeave: "Resterend verlof",
  ValidFrom: "Geldig van",
  ValidTo: "Geldig tot",
  Leaverequests: "Verlofaanvragen",
  NewLeaverequest: "Nieuwe verlofaanvraag",
  Type: "Type",
  HalfDayDate: "Halve dag datum",
  CompensatoryAllocation: "Compensatie toewijzing",
  ReportRecover: "Rapport terugvordering",
  LeaveRequestDeletedsuccessfully: "Verlofaanvraag succesvol verwijderd",
  LeaveRequestupdatedsuccessfully: "Verlofaanvraag succesvol bijgewerkt",
  LeaveRequestcancelledsuccessfully: "Verlofaanvraag succesvol geannuleerd",
  Leavemarkedasrecoveredsuccessfully:
    "Verlof succesvol als teruggevorderd gemarkeerd",
  Areyousureyouwantto: "Weet je zeker dat je",
  this: "dit wilt",
  Enterrecovereddate: "Voer terugvorderingsdatum in",
  ToDate: "Tot datum",
  Leaveallocatedsuccessfully: "Verlof succesvol toegewezen",
  FromDate: "Van datum",
  LeaveAllocationupdatedsuccessfully: "Verloftoewijzing succesvol bijgewerkt",
  NewLeavesAllocated: "Nieuw verlof toegewezen",
  Addunusedleavesfrompreviousallocations:
    "Voeg ongebruikte verlofdagen toe van vorige toewijzingen",
  TotalLeavesAllocated: "Totaal toegewezen verlofdagen",
  Unusedleaves: "Ongebruikte verlofdagen",
  LeaveRequest: "Verlofaanvraag",
  Leaverequestapplysuccessfully: "Verlofaanvraag succesvol ingediend",
  Reason: "Reden",
  AddHoliday: "Feestdag toevoegen",
  Leaveoverview: "Verlofoverzicht",
  AbsenceOverview: "Afwezigheidsoverzicht",
  Agenda: "Agenda",
  HolidayListName: "Naam feestdagenlijst",
  Holiday: "Feestdag",
  AddHolidayList: "Feestdagenlijst toevoegen",
  AddLeaveType: "Verloftype toevoegen",
  AddLeavePolicy: "Verlofbeleid toevoegen",
  LeavePolicies: "Verlofbeleiden",
  OptionalHolidays: "Optionele feestdagen",
  Name: "Naam",
  TotalHolidays: "Totaal aantal feestdagen",
  Description: "Beschrijving",
  HolidayDate: "Datum feestdag",
  description: "deschrijving",
  AddWeeklyHoliday: "Wekelijkse feestdag toevoegen",
  Holidays: "Feestdagen",
  LeaveTypeupdatedsuccessfully: "Verloftype succesvol bijgewerkt",
  CarryForward: "Overdragen",
  LeaveWithoutPay: "Onbetaald verlof",
  OptionalLeave: "Optioneel verlof",
  Compensatory: "Compensatoir verlof",
  LeaveTypeaddedsuccessfully: "Verloftype succesvol toegevoegd",
  LeaveTypeName: "Naam verloftype",
  MaximumConsecutiveLeavesAllowed:
    "Maximaal aantal opeenvolgende verlofdagen toegestaan",
  MaximumCarryForwardedLeaves: "Maximaal aantal overdraagbare verlofdagen",
  ExpireCarryForwardedLeavesDays: "Verlopen overgedragen verlofdagen (dagen)",
  AllocateonDay: "Toewijzen op dag",
  FirstDay: "Eerste dag",
  LastDay: "Laatste dag",
  DateofJoining: "Datum indiensttreding",
  IsCarryForward: "Is overdraagbaar",
  IsLeaveWithoutPay: "Is onbetaald verlof",
  IsOptionalLeave: "Is optioneel verlof",
  AllowOverAllocation: "Overtoewijzing toestaan",
  Allowsallocatingmoreleavesthanthenumberofdaysintheallocationperiod:
    "Staat toe om meer verlofdagen toe te wijzen dan het aantal dagen in de toewijzingsperiode",
  IsCompensatory: "Is compensatoir verlof",
  IsEarnedLeave: "Is verdiend verlof",
  IsSickLeave: "Is ziekteverlof",
  LeavePolicyaddedsuccessfully: "Verlofbeleid succesvol toegevoegd",
  LeaveTypes: "Verloftypes",
  AnnualAllocation: "Jaarlijkse toewijzing",
  LeaveTypeList: "Lijst van verloftypes",
  AddLeavePolicyDetails: "Verlofbeleiddetails toevoegen",
  LeaveSettings: "Verlofinstellingen",
  Period: "Periode",
  approve: "Goedkeuren",
  reject: "Afwijzen",
  Leavecancelledsuccessfully: "Verlof succesvol geannuleerd",
  Explanation: "Toelichting",
  CompensatoryLeaveRequestupdatedsuccessfully:
    "Compensatoire toewijzingsaanvraag succesvol bijgewerkt",
  TotalDuration: "Totale duur",
  CompensatoryAllocationRequest: "Compensatoire toewijzingsaanvraag",
  LeaveBlockList: "Verlofblokkadelijst",
  AddLeaveBlockList: "Verlofblokkadelijst toevoegen",
  LeaveBlockListName: "Naam verlofblokkadelijst",
  BlockDays: "Geblokkeerde dagen",
  AddDaywiseDates: "Dag-voor-dag data toevoegen",
  LeaveBlockListDates: "Datums verlofblokkadelijst",
  BlockDate: "Blokdatum",
  AddBlockDay: "Blokdag toevoegen",
  StopusersfrommakingLeaveApplicationsonfollowingdays:
    "Voorkom dat gebruikers verlofaanvragen indienen op de volgende dagen",
  AddLeaveBlockDates: "Blokdatums toevoegen",
  Pleaseselectdays: "Selecteer dagen",
  LeaveBlockListaddedsuccessfully: "Verlofblokkadelijst succesvol toegevoegd",
  LeaveBlockListupdatedsuccessfully: "Verlofblokkadelijst succesvol bijgewerkt",
  AddFolder: "Map toevoegen",
  AddDocument: "Document toevoegen",
  Mydocuments: "Mijn documenten",
  Folderaddedsuccessfully: "Map succesvol toegevoegd",
  Folder: "Map",
  FileName: "Bestandsnaam",
  Documentaddedsuccessfully: "Document succesvol toegevoegd",
  Documentupdatedsuccessfully: "Document succesvol bijgewerkt",
  SelectDocument: "Selecteer document",
  Sharewithemployee: "Delen met medewerker",
  Folderupdatedsuccessfully: "Map succesvol bijgewerkt",
  FolderDeletedsuccessfully: "Map succesvol verwijderd",
  EmptyFolder: "Lege map",
  EditDocument: "Document bewerken",
  EditFolder: "Map bewerken",
  Documentdeletedsuccessfully: "Document succesvol verwijderd",
  HalfDay: "Halve dag",
};
